export default{
  shortUrl: [],
  url: '',
  longUrl: '',
  custom: '',
  urlHistory: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/urltools/state.js